"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("../../../internal/query");
var BaseQuery = (function () {
    function BaseQuery(queryExecuter, method, resourceType, resourceName) {
        this.queryExecuter = queryExecuter;
        this.method = method;
        this.resourceType = resourceType;
        this.resourceName = resourceName;
        this.query = new query_1.Query();
    }
    BaseQuery.prototype.fields = function (field) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        this.query.fields = Array.isArray(field) ? field : __spreadArrays([field], fields);
        return this;
    };
    Object.defineProperty(BaseQuery.prototype, "compiledRequest", {
        get: function () {
            return {
                resourceType: this.resourceType,
                resourceName: this.resourceName,
                method: this.method,
                body: this.body || {},
                queryParams: this.query.compileToQueryParams() || [],
            };
        },
        enumerable: true,
        configurable: true
    });
    BaseQuery.prototype.execute = function () {
        return this.queryExecuter.executeRequest(this.compiledRequest);
    };
    return BaseQuery;
}());
exports.BaseQuery = BaseQuery;
